import React, { useEffect, useState } from 'react';

interface TimerProps {
  hours: number;
  minutes: number;
  seconds: number;
}

const Timer: React.FC<TimerProps> = ({ hours, minutes, seconds }) => {
  const [remainingHours, setRemainingHours] = useState(hours);
  const [remainingMinutes, setRemainingMinutes] = useState(minutes);
  const [remainingSeconds, setRemainingSeconds] = useState(seconds);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      if (remainingSeconds > 0) {
        setRemainingSeconds(remainingSeconds - 1);
      } else if (remainingMinutes > 0) {
        setRemainingMinutes(remainingMinutes - 1);
        setRemainingSeconds(59);
      } else if (remainingHours > 0) {
        setRemainingHours(remainingHours - 1);
        setRemainingMinutes(59);
        setRemainingSeconds(59);
      } else {
        clearInterval(timerInterval);
      }
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [remainingHours, remainingMinutes, remainingSeconds]);

  return (
    <span>
      {`${remainingHours?.toString()?.padStart(2, '0')}h ${remainingMinutes
        ?.toString()
        ?.padStart(2, '0')}m ${remainingSeconds?.toString()?.padStart(2, '0')}s`}
    </span>
  );
};

export default Timer;
